/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TotalOverview.vue?vue&type=template&id=3d05a658&scoped=true"
import script from "./TotalOverview.vue?vue&type=script&lang=js"
export * from "./TotalOverview.vue?vue&type=script&lang=js"
import style0 from "./TotalOverview.vue?vue&type=style&index=0&id=3d05a658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05a658",
  null
  
)

export default component.exports